<div class="w-full py-3 px-4">
  <!-- Header -->
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-2">
      <a [routerLink]="['/order']" aria-label="Go to orders">
        <svg class="size-6 text-c19725" viewBox="0 0 24 24" fill="currentColor">
          <path d="M15 19l-7-7 7-7" />
        </svg>
      </a>

      <img src="/assets/images/stock/raw-material.png" class="size-7" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-[#444]">
        Issue Raw Material
      </span>
    </div>
  </div>

  <!-- Selected Raw Material Details (Compact) -->
  <div
    *ngIf="selectedStock"
    class="mb-3 p-3 rounded-lg border border-[#e6d8a8] bg-[#FFFBEE]"
  >
    <!-- Header -->
    <div class="flex items-center justify-between mb-2">
      <h3 class="text-xs font-semibold text-[#8a6d1d]">
        Selected Raw Material
      </h3>

      <span
        class="px-1.5 py-0.5 text-[10px] rounded-full bg-c19725 text-white capitalize"
      >
        {{ selectedStock.st_product_code_type.replace("_", " ") }}
      </span>
    </div>

    <!-- Details Grid -->
    <div
      class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-x-3 gap-y-2 text-xs"
    >
      <!-- Code -->
      <div>
        <p class="text-[#898989]">Code</p>
        <p class="font-medium truncate">
          {{ selectedStock.st_item_code }}
        </p>
      </div>

      <!-- Name -->
      <div>
        <p class="text-[#898989]">Name</p>
        <p class="font-medium truncate">
          {{ selectedStock.st_item_name }}
        </p>
      </div>

      <!-- Category -->
      <div>
        <p class="text-[#898989]">Category</p>
        <p class="font-medium truncate">
          {{ selectedStock.st_item_category?.name || "-" }}
        </p>
      </div>

      <!-- Available Qty -->
      <div>
        <p class="text-[#898989]">Available</p>
        <p class="font-semibold text-green-700">
          {{ selectedStock.st_quantity }} {{ selectedStock.st_unit }}
        </p>
      </div>

      <!-- Rate -->
      <div *ngIf="selectedStock.st_unit_price">
        <p class="text-[#898989]">Rate</p>
        <p class="font-medium">₹ {{ selectedStock.st_unit_price }}</p>
      </div>

      <!-- Updated -->
      <div>
        <p class="text-[#898989]">Updated</p>
        <p class="font-medium">
          {{ selectedStock.updated_at | date : "dd MMM yyyy" }}
        </p>
      </div>

      <!-- ===== METAL FIELDS ===== -->
      <ng-container *ngIf="selectedStock.st_product_code_type === 'raw_metal'">
        <div>
          <p class="text-[#898989]">Metal</p>
          <p class="font-medium">
            {{ selectedStock.st_metal_type || "-" }}
          </p>
        </div>

        <div>
          <p class="text-[#898989]">Per Pc Wt</p>
          <p class="font-medium">{{ selectedStock.st_subunit || 0 }} GM</p>
        </div>

        <div *ngIf="selectedStock.st_total_wt">
          <p class="text-[#898989]">Total Wt</p>
          <p class="font-medium">{{ selectedStock.st_total_wt }} GM</p>
        </div>

        <div *ngIf="selectedStock.st_purity">
          <p class="text-[#898989]">Purity</p>
          <p class="font-medium">
            {{ selectedStock.st_purity }}
          </p>
        </div>
      </ng-container>

      <!-- ===== STONE FIELDS ===== -->
      <ng-container *ngIf="selectedStock.st_product_code_type === 'raw_stone'">
        <div>
          <p class="text-[#898989]">Stone</p>
          <p class="font-medium">
            {{ selectedStock.st_stone_category || "-" }}
          </p>
        </div>

        <div>
          <p class="text-[#898989]">Size</p>
          <p class="font-medium">
            {{ selectedStock.st_size || "-" }}
          </p>
        </div>

        <div>
          <p class="text-[#898989]">Pieces</p>
          <p class="font-medium">
            {{ selectedStock.st_quantity }}
          </p>
        </div>
      </ng-container>
    </div>
  </div>

  <form [formGroup]="issueRawForm">
    <div
      class="w-full bg-[#FFF5F2] p-4 rounded-lg grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols- gap-3"
    >
      <!-- Stone / Metal -->
      <div class="relative">
        <select
          formControlName="ordc_request_type"
          class="peer block px-3 py-2 w-full bg-white rounded-md border border-[#dcdcdc] text-sm focus:outline-none focus:border-c19725"
        >
          <option value="" disabled selected></option>
          <option value="raw_metal">Metal</option>
          <option value="raw_stone">Stone</option>
        </select>

        <label
          class="absolute left-2 top-2.5 text-sm text-[#898989] bg-white px-1 transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-c19725 peer-not-placeholder-shown:-top-2 peer-not-placeholder-shown:text-xs"
        >
          Stone / Metal
        </label>
      </div>

      <!-- Raw Material Code -->
      <div class="relative">
        <select
          formControlName="ordc_product_code" placeholder="select Material"
          (change)="onProductCodeSelect($event)"
          class="peer block px-3 py-2 w-full bg-white rounded-md border border-[#dcdcdc] text-sm"
        >
          <option value="" disabled selected></option>
          <option
            *ngFor="let item of filteredStocks"
            [value]="item.st_item_code"
          >
            {{ item.st_item_code }} - {{ item.st_item_name }}
          </option>
        </select>

        <label
          class="absolute left-2 top-2.5 text-sm text-[#898989] bg-white px-1 transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-c19725 peer-not-placeholder-shown:-top-2 peer-not-placeholder-shown:text-xs"
        >
          Raw Material Code
        </label>
      </div>

      <div class="relative">
        <input
          type="text"
          formControlName="ordc_product_name"
          readonly
          class="peer px-3 py-2 w-full bg-gray-50 rounded-md border border-[#dcdcdc] text-sm"
        />
        <label
          class="absolute left-2 -top-2 text-xs text-[#898989] bg-white px-1"
        >
          Name
        </label>
      </div>

      <div class="relative">
        <input
          type="text"
          formControlName="ordc_unit"
          readonly
          class="peer px-3 py-2 w-full bg-gray-50 rounded-md border border-[#dcdcdc] text-sm"
        />
        <label
          class="absolute left-2 -top-2 text-xs text-[#898989] bg-white px-1"
        >
          Unit
        </label>
      </div>

      <div class="relative">
        <input
          type="text"
          formControlName="ordc_available_quantity"
          readonly
          class="peer px-3 py-2 w-full bg-green-50 rounded-md border border-green-300 text-sm text-green-700 font-semibold"
        />
        <label
          class="absolute left-2 -top-2 text-xs text-green-700 bg-white px-1"
        >
          Available Qty
        </label>
      </div>
      <div class="relative">
        <input
          type="number"
          formControlName="ordc_quantity"
          class="peer px-3 py-2 w-full bg-white rounded-md border border-[#dcdcdc] text-sm"
        />
        <label
          class="absolute left-2 top-2.5 text-sm text-[#898989] bg-white px-1 transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-c19725 peer-not-placeholder-shown:-top-2 peer-not-placeholder-shown:text-xs"
        >
          Issue Qty
        </label>
      </div>

      <div class="relative">
        <select
          formControlName="ordc_assined_to"
          class="peer px-3 py-2 w-full bg-white rounded-md border border-[#dcdcdc] text-sm"
        >
          <option value="" disabled selected></option>
          <option *ngFor="let user of kalakarSuppliers" [value]="user.id">
            {{ user.name }}
          </option>
        </select>
        <label
          class="absolute left-2 top-2.5 text-sm text-[#898989] bg-white px-1 transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-c19725 peer-not-placeholder-shown:-top-2 peer-not-placeholder-shown:text-xs"
        >
          Assign To
        </label>
      </div>

      <div class="col-span flex justify-end gap-1">
        <button
          type="button"
          (click)="issueMaterial()"
          [disabled]="
            issueRawForm.invalid ||
            issueRawForm.get('ordc_available_quantity')?.value <= 0 ||
            issueRawForm.get('ordc_quantity')?.value >
              issueRawForm.get('ordc_available_quantity')?.value
          "
          class="px-4 py-2 bg-c19725 text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Issue
        </button>

        <button
          type="button"
          (click)="clearForm()"
          class="px-5 py-2 bg-red-600 text-white text-sm rounded-md hover:bg-red-700"
        >
          Clear
        </button>
      </div>
    </div>

    <div class="bg-white rounded-lg mt-6 p-4" *ngIf="issuedList.length">
      <h3 class="text-base font-semibold mb-3 text-[#444]">
        Issued Raw Material (Pending Hand Over)
      </h3>

      <div class="overflow-x-auto hidden sm:block">
        <table class="w-full text-sm border rounded-md overflow-hidden">
          <thead class="bg-gray-100 text-gray-700">
            <tr>
              <th class="p-2 border">Code</th>
              <th class="p-2 border">Name</th>
              <th class="p-2 border">Qty</th>
              <th class="p-2 border">Assigned To</th>
              <th class="p-2 border text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="let row of issuedList"
              class="hover:bg-gray-50 transition"
            >
              <td class="p-2 border">{{ row.product_code }}</td>
              <td class="p-2 border font-medium">{{ row.product_name }}</td>
              <td class="p-2 border font-semibold text-c19725">
                {{ row.quantity }}
              </td>
              <td class="p-2 border">
                {{ getAssigneeName(row.assigned_to) }}
              </td>
              <td class="p-2 border text-center">
                <button
                  class="px-3 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700"
                  (click)="handOver(row.id)"
                >
                  Hand Over
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</div>
